import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { customMedia } from '../../common/customMedia'
import { Image } from '../../common/Image'
import { Acumin } from '../../common/Acumin'
import { SpOnly } from '../../common/SpOnly'
import { PcOnly } from '../../common/PcOnly'

const gif1Src = require('../../../images/palo-santo/vol5_01.gif')
const gif2Src = require('../../../images/palo-santo/vol5_02.gif')
const gif3Src = require('../../../images/palo-santo/vol5_03.gif')

export const PaloSanto = () => {
  const [width, setWidth] = useState(0)
  const [showPhone, setShowPhone] = useState(false)
  const [hidePhone, setHidePhone] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setWidth(0)
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    handleResize()
  }, [])

  const handleClickPlayButton = () => {
    if (!showPhone && !hidePhone) {
      setShowPhone(true)
    } else {
      setShowPhone(!showPhone)
      setHidePhone(!hidePhone)
    }
  }

  return (
    <>
      <OverflowHidden>
        <Container>
          <div className="section1">
            <Image path='palo-santo/mainitem.jpg' />

            <div className="content">
              <div className="name">
                asebi Palo Santo +<br />
                Palo Santo tray drawing by UE
              </div>
              <div className="description">
                “楽しい人生”の中からうまれた物作りが、楽しく生きたいと思える人たちに繋がっていきますように。そんな願いから生まれたライフスタイルブランド『asebi』がオススメする天然の香木パロサントと、独自の技術と感性を磨きながら日々、刺青道を邁進するタトゥーアーティストUEが描くトレーをセットにしてお届けします。皆さんと出会えた奇跡に感謝カンゲキ雨あられ。のちにパロサント。普段の何気ない生活にハピネスと創造力をもたらせること間違いなしの聖なるアイテムを、ぜひこの機会にお楽しみください！
                <br />
                <br />
                Have good luck
              </div>
            </div>
          </div>

          <div className="section2">
            <SpOnly>
              <img src={gif1Src} alt={gif1Src} />
            </SpOnly>
            <div className="content">
              <div className="name">asebi Palo Santo</div>
              <div className="description">
                天然の香木で「聖なる樹」と呼ばれています。古くからシャーマンたちが儀式の際に場を清めるためにパロサントを焚いて使用していました。リラックス効果があり空気の清浄、瞑想の導入に使用することもおすすめです。エクアドルやペルーでは、創造力を高めて幸運をもたらすと言われています。着火せず玄関やお部屋に置く場合は、ほのかな香りを長期間楽しめます。スティック状のまま火を点け消すと、 煙がたちます。(火がつきにくい場合は約１分程燃やしてください)<br/>
                浴槽の中に入れればパロサントバスに。クローゼット等の防虫での使用も可能。森の中にいるようなやわらかく濃厚な香りがします。<br />
                ※火の取り扱いには十分ご注意ください。使用後は必ず消火していることをご確認ください。<br />
                ※パロサントの箱に付いているステッカーは剥がして使用出来ます。<br />
                ※こちらのプレートは電子レンジ、食洗機も通常通りお使いいただけます。
              </div>
            </div>
            <PcOnly>
              <img src={gif1Src} alt={gif1Src} />
            </PcOnly>
          </div>

          <div className="section3">
            <div>
              <Image path='palo-santo/02.jpg' />
              <img src={gif2Src} alt={gif2Src} />
            </div>
            <div className="content">
              <Image path='palo-santo/Artist1.jpg' />
              <div>
                <div className="title">Tattoo Artist</div>
                <div className="name"><span>UE</span> <span className="store-name">(THE PARLOUR)</span></div>
                <div className="description">
                  中目黒のタトゥーショップ「THE PARLOUR」のタトゥーアーティスト。中目黒を拠点に国内外で活躍する傍ら、様々なタトゥーコンベンションやアートショーにも参加。オールドスクールをベースにボールドラインやラインレスなど、様々な独自の手法を取り入れ日々刺青道を邁進中。
                </div>
                <div className="instagram">
                  <span>HP：</span> <a href="https://bromahouse.stores.jp" target="_blank">bromahouse.stores.jp</a><br />
                  <span>Instagram：</span> <a href="https://instagram.com/ue_the_parlour" target="_blank">@ue_the_parlour</a>
                </div>
              </div>
            </div>
          </div>

          <div className="section4">
            <PcOnly>
              <div className="images">
                <Image path='palo-santo/Artist2.jpg' />
                <Image path='palo-santo/01.jpg' />
              </div>
            </PcOnly>
            <SpOnly>
              <Image path='palo-santo/01.jpg' />
              <img src={gif3Src} alt={gif3Src} />
            </SpOnly>
            <div className="content">
              <SpOnly>
                <Image path='palo-santo/Artist2.jpg' />
              </SpOnly>
              <div className="content-right">
                <div className="title">Lifestyle Brand</div>
                <div className="name">asebi</div>
                <div className="description">
                  "楽しい人生"の中でうまれた物作りを、楽しく生きたいと思える人たちに繋がっていきますように。そんな願いから生まれたライフスタイルブランドです。2020年 Aya/Arisaでasebiを立ち上げアセビの花言葉〝あなたと二人で旅をしましょう〟という言葉のように私たちがお届けするものが皆さまの人生という旅に寄り添えるようなものづくりを提案します。<br />
                  I BELIEVE AND I'M SURE,<br />
                  WE CAN DO SOMETHING FOR<br />
                  JUST LOVE & PEACE.
                </div>
                <div className="instagram">
                  <span>HP：</span> <a href="https://asebi.stores.jp" target="_blank">asebi.stores.jp</a><br />
                  <span>Instagram：</span> <a href="https://instagram.com/asebi___" target="_blank">@asebi___</a>
                </div>
              </div>
              <PcOnly>
                <div className="gif3">
                  <img src={gif3Src} alt={gif3Src} />
                </div>
              </PcOnly>
            </div>
          </div>
        </Container>
      </OverflowHidden>
    </>
  )
}

const OverflowHidden = styled.div`
  overflow: hidden;
`

const Container = styled.div`
  .instagram {
    a {
      color: #000;
    }
  }

  @media screen and ( max-width: 768px ) {
    padding: 0 20px;

    .instagram {
      font-size: 0.8rem;
      margin: 5px 0 20px;

      span {
        font-weight: bold;
      }
    }
  }

  @media screen and ( min-width: 769px ) {
    margin: 80px auto 0;
    width: 1000px;

    .instagram {
      font-size: 1.2rem;
      margin: 10px 0 100px;

      span {
        font-weight: bold;
      }
    }
  }

  .title, .name {
    font-family: 'EB Garamond', serif;
    font-weight: bold;
  }
  
  .title {
    @media screen and ( max-width: 768px ) {
      font-size: 1rem;
    }
    @media screen and ( min-width: 769px ) {
      font-size: 2rem;
      margin-bottom: -14px;
    }
  }

  .name {
    @media screen and ( max-width: 768px ) {
      font-size: 3rem;
    }
    @media screen and ( min-width: 769px ) {
      font-size: 4rem;
      text-align: center;
      margin-bottom: 24px;
    }
  }

  .description {
    font-family: 'TsukuBRdGothic-Regular',sans-serif;

    @media screen and ( max-width: 768px ) {
      font-size: 1.2rem;
    }
    @media screen and ( min-width: 769px ) {
      font-size: 1.5rem;
      line-height: 2.8rem;
    }
  }

  .section1 {
    @media screen and ( max-width: 768px ) {
      margin-top: 48px;
    }
    @media screen and ( min-width: 769px ) {
      .gatsby-image-wrapper {
        margin: 0 auto;
        width: 800px;
      }
    }

    .content {
      @media screen and ( max-width: 768px ) {
        .description {
          margin-top: 12px;
        }
      }
      @media screen and ( min-width: 769px ) {
        margin: 0 auto;
        width: 620px;
      }
    }
  }

  .section2 {
    @media screen and ( max-width: 768px ) {
      img {
        margin: 48px auto 24px;
        width: 80%;
      }

      .content {
        .description {
          margin: 6px 0 48px;
        }
      }

      .artist, .shop {
        display: flex;

        .gatsby-image-wrapper {
          width: 40%;

          img {
            height: auto !important;
            object-fit: fill !important;
          }
        }

        .artist-content, .shop-content {
          padding-left: 10px;
          width: 60%;
        }
      }

      .gatsby-image-wrapper {
        margin-bottom: 20px;
      }
    }
    @media screen and ( min-width: 769px ) {
      display: flex;
      justify-content: space-between;
      margin-top: 100px;

      .content {
        width: 55%;

        .name {
          margin-bottom: 0;
          text-align: left; 
        }
      }

      img {
        height: 205px;
        width: 308px;
      }
    }
  }

  .section3 {
    @media screen and ( max-width: 768px ) {
      img {
        margin: 0 auto;
        width: 80%;
      }

      .gatsby-image-wrapper {
        margin: 0 auto 24px;
        width: 80%;
      }

      .content {
        display: flex;
        margin-top: 36px;
        
        .name {
          display: flex;
          align-items: center;
          height: 30px;
          span {
            display: inline-block;

            &.store-name {
              margin-left: 4px;
              font-size: 20px;
            }
          }
        }

        .gatsby-image-wrapper {
          width: 30%;

          img {
            height: auto !important;
            object-fit: fill !important;
          }
        }

        > div {
          padding-left: 20px;
          width: 70%;
        }
      }
    }
    @media screen and ( min-width: 769px ) {
      margin-top: 100px;
      display: flex;
      justify-content: space-between;

      .gatsby-image-wrapper {
        width: 400px;
        margin-bottom: 80px;
  
        > img {
          height: auto !important;
          object-fit: fill !important;
        }
      }

      img {
        height: 205px;
        width: 308px;
      }
  
      .content {
        width: 40%;

        .name {
          margin-top: 4px;
          margin-bottom: 0;
          text-align: left; 
        }
  
        .gatsby-image-wrapper {
          margin-bottom: 20px;
          width: 400px;
        }
      }
    }
  }

  .section4 {
    @media screen and ( max-width: 768px ) {      
      .gatsby-image-wrapper {
        margin: 24px auto 24px;
        width: 80%;
      }

      img {
        margin: 0 auto 0;
        width: 80%;
      }

      .content {
        display: flex;
        margin-top: 36px;

        .gatsby-image-wrapper {
          margin-top: 10px;
          width: 100px;
        }

        .content-right {
          padding-left: 8px;
        }
        
        .title {
          font-size: 16px;
        }

        .name {
          margin-top: -6px;
        }
      }
    }
    @media screen and ( min-width: 769px ) {
      .images {
        display: flex;
        justify-content: space-between;

        .gatsby-image-wrapper {
          width: 40%;
          
          &:first-child {
            margin-top: 200px;
            img {
              height: auto !important;
            }
          }

          &:nth-child(2) {
            margin-top: 120px;
          }
        }
      }

      .content {
        display: flex;
        margin-top: -64px;

        .name {
          text-align: left;
          margin-top: 8px;
          margin-bottom: 0;
        }

        .description {
          width: 480px;
        }

        .content-right {
          width: 700px;
        }

        .gif3 {
          margin-top: 150px;

          img {
            width: 300px;
          }
        }
      }
    }
  }
`


const ProductContainer = styled.div`
  ${customMedia.lessThan("medium")`
    margin: 40px 20px 0;
  `}
  ${customMedia.greaterThan("medium")`
  `}

  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
`

const Image4Wrapper = styled.div`
  ${customMedia.lessThan("medium")`
    -webkit-flex-basis: 100px;
    flex-basis: 100px;
    margin-right: 20px;
  `}
  ${customMedia.greaterThan("medium")`
    -webkit-flex-basis: 300px;
    flex-basis: 300px;
  `}

  flex: none;
  position: relative;
`

const ProductDetails = styled.div`
  ${customMedia.lessThan("medium")`
  `}
  ${customMedia.greaterThan("medium")`
    margin: 0 0 0 50px;
  `}

  position: relative;
`

const ProductName = styled.div`
  ${customMedia.lessThan("medium")`
  `}
  ${customMedia.greaterThan("medium")`
  `}
`

const ProductDescription = styled.div`
  ${customMedia.lessThan("medium")`
    font-size: 1rem;
    line-height: 15px;
    margin-right: 20px;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 1.6rem;
    line-height: 30px;
  `}

  font-family: 'TsukuBRdGothic-Regular',sans-serif;
  text-align: justify;
`

const BoxGifWrapper = styled.div`
  ${customMedia.lessThan("medium")`
    margin-top: 40px;
    width: 130px;
  `}
  ${customMedia.greaterThan("medium")`
    margin: 50px 0 0 160px;
    width: 360px;
  `}
`

const ArtistAndShopContainer = styled.div`
  ${customMedia.lessThan("medium")`
    margin: 50px 0;
  `}
  ${customMedia.greaterThan("medium")`
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    margin-top: 50px;
  `}
`

const ArtistAndShopDetails = styled.div`
  ${customMedia.lessThan("medium")`
    display: -webkit-flex;
    display: flex;
    margin-top: 20px;
  `}
  ${customMedia.greaterThan("medium")`
  `}

  z-index: 99;
`

const ArtistAndShopDetailContainer = styled.div`
${customMedia.lessThan("medium")`
  margin: 0 20px;
`}
${customMedia.greaterThan("medium")`
`}

z-index: 99;
`

const ArtistAndShopTitle = styled.div`
  ${customMedia.lessThan("medium")`
    * { font-size: 1rem; }
    height: 8px;
  `}
  ${customMedia.greaterThan("medium")`
    * { font-size: 2rem; }
    height: 12px;
    margin-top: 10px;
  `}
`

const ArtistAndShopNameEn = styled.div`
  ${customMedia.lessThan("medium")`
  `}
  ${customMedia.greaterThan("medium")`
  `}
`

const Image5Wrapper = styled.div`
  ${customMedia.lessThan("medium")`
    margin-left: 20px;
    width: 100px;
  `}
  ${customMedia.greaterThan("medium")`
    margin-top: 100px;
    width: 300px;
  `}

  flex: none;
  z-index: -1;
`

const Image6Wrapper = styled.div`
  ${customMedia.lessThan("medium")`
    margin: 0 auto;
    width: 120px;

    div {
      font-size: 8px;
      margin-top: 5px;
    }
  `}
  ${customMedia.greaterThan("medium")`
    width: 280px;
    margin-right: 48px;

    div {
      font-size: 1.4rem;
    }
  `}

  flex: none;
  text-align: center;
`

const Image7Wrapper = styled.div`
  ${customMedia.lessThan("medium")`
    margin-left: 20px;
    width: 120px;
  `}
  ${customMedia.greaterThan("medium")`
    margin-top: 100px;
    width: 300px;
  `}

  flex: none;
  z-index: -1;
`

const ArtistAndShopDescription = styled.div`
  ${customMedia.lessThan("medium")`
    font-size: 1rem;
    line-height: 15px;
    margin-right: 20px;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 1.6rem;
    line-height: 30px;
    margin-right: 100px;
    width: 468px;
  `}

  font-family: 'TsukuBRdGothic-Regular',sans-serif;
  text-align: justify;
`

const Image8Wrapper = styled.div`
  ${customMedia.lessThan("medium")`
    margin: 0 auto;
    width: 250px;

    div {
      font-size: 8px;
      margin-top: 5px;
    }
  `}
  ${customMedia.greaterThan("medium")`
    width: 400px;
    margin-top: 60px;

    div {
      font-size: 1.4rem;
    }
  `}

  flex: none;
  text-align: center;
`

const Instagram = styled.div<{ align?: string }>`
  ${customMedia.lessThan("medium")`
    font-size: 0.8rem;
    margin-top: 10px;

    span {
      font-size: 6px;
    }
  `}
  ${props => customMedia.greaterThan("medium")`
    font-size: 1.6rem;
    ${props.align && `text-align: ${props.align}`};
    
    span {
      font-size: 1.2rem;
    }
  `}

  font-family: 'Noto Sans JP', sans-serif;
  font-style: normal;
  text-align: left;

  span {
    font-weight: bold;
  }
`